import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useRef, useState } from "react";
import type { FanChoice } from "../../shared/fan-voting";
import { fansQuery, queryKeys } from "./queries";
import { useTournament } from "./tournament";

export function useFans() {
  const { id, api } = useTournament();
  const client = useQueryClient();
  const query = useQuery(fansQuery(id));
  const voting = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const vote = async (choice: FanChoice) => {
    if (voting.current) return false;
    voting.current = true;
    setBusy(true);
    setError(null);
    setSaved(false);
    try {
      await client.cancelQueries({ queryKey: queryKeys.fans(id) });
      client.setQueryData(queryKeys.fans(id), await api.voteFan(choice));
      setSaved(true);
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      void client.invalidateQueries({ queryKey: queryKeys.fans(id) });
      return false;
    } finally {
      voting.current = false;
      setBusy(false);
    }
  };
  const refresh = () => {
    setError(null);
    setSaved(false);
    void query.refetch();
  };
  return { ...query, busy, error: error ?? query.error?.message ?? null, saved, vote, refresh };
}
